/*
 * Public API Surface of pepperi-lib/menu
 */
export * from './menu.module';
export * from './menu.component';
